import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

import { ButtonProps } from '@mui/material';

export interface IStyledButton extends ButtonProps {
  layout?: 'primary' | 'outline' | 'secondary';
}
export const CustomButton = styled(Button)<IStyledButton>(
  ({ theme, layout } : any) =>
    layout === 'primary' && {
      borderRadius: '8px',
      backgroundColor: theme.colors.secondary.secondary_50,
      '&:hover': {
        backgroundColor: theme.colors.secondary.secondary_50,
      },
      color: theme.colors.semantic.semantic_white,
      textTransform: 'none',
      width: '100%',
      padding: '0.625rem 1.125rem',
      boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
      '&:disabled': {
        backgroundColor: `${theme.colors.neutrals.neutrals_20} !important`,
        cursor: 'not-allowed',
      },
    },
  ({ theme, layout } : any) =>
    layout === 'outline' && {
      color: theme.colors.neutrals.neutrals_90,
      borderRadius: '8px',
      borderStyle: 'solid',
      borderWidth: '1px',
      textTransform: 'none',
      padding: '8px 16px',
      width : '100%',
      borderColor: theme.colors.neutrals.neutrals_70,
      boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
      backgroundColor: theme.colors.semantic.semantic_white
    },
  ({ theme, layout } : any) =>
    layout === 'secondary' && {
      color: theme.colors.semantic.semantic_white,
      borderRadius: '8px',
      borderStyle: 'solid',
      borderWidth: '1px',
      textTransform: 'none',
      backgroundColor: 'white',
      width: '1.625rem',
      minWidth: '1.625rem !important',
      padding: '0 !important',
      '.MuiButton-startIcon': {
        margin: '0rem !important',
        border: 'none',
        display: 'block',
      },
      '&:disabled': {
        backgroundColor: `${theme.colors.neutrals_20} !important`,
        cursor: 'not-allowed',
      },
    }
);
